import { SET_ACTIVE_PRESET, CLEAR_ACTIVE_PRESET, CLEAR_SELECTED_PRESET, FETCH_PRESETS, SET_SELECTED_PRESET, SET_IGNORE_USER_THEME_OVERRIDES, THEME_SETTINGS_UPDATED, SET_IS_PRESET_PANEL_OPEN, THEME_SETTINGS_CHANGE_UNDONE, THEME_SETTINGS_CHANGE_REDONE, THEME_AND_SETTINGS_FETCHED, FETCH_THEME_SUCCEEDED, THEME_SETTINGS_BUFFER_PUBLISHED } from '../actions/ActionTypes';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import { convertChirpFieldValueObjectToJson } from '../utils/chirp';
const DEFAULT_STATE = {
  presetsById: {},
  requestStatus: RequestStatusTypes.UNINITIALIZED,
  selectedThemePresetId: undefined // Preset ID that is currently selected to preview in the UI
};
const presetsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_PRESETS:
      {
        const {
          requestStatus,
          results,
          error
        } = action;
        if (requestStatus === RequestStatusTypes.PENDING) {
          return Object.assign({}, state, {
            requestStatus: RequestStatusTypes.PENDING
          });
        }
        if (requestStatus === RequestStatusTypes.SUCCEEDED && results) {
          const presetsById = results.reduce((acc, preset) => {
            acc[preset.id] = Object.assign({}, preset, {
              // TODO: remove this once presets have type properties
              type: preset.name.includes('preset') ? 'DEFAULT' : 'CUSTOM',
              styles: convertChirpFieldValueObjectToJson(preset.styles)
            });
            return acc;
          }, {});
          return Object.assign({}, state, {
            presetsById,
            requestStatus: RequestStatusTypes.SUCCEEDED
          });
        }
        if (requestStatus === RequestStatusTypes.FAILED && error) {
          return Object.assign({}, state, {
            requestStatus: RequestStatusTypes.FAILED
          });
        }
        return state;
      }
    case THEME_AND_SETTINGS_FETCHED:
    case FETCH_THEME_SUCCEEDED:
      {
        if (action.requestStatus === RequestStatusTypes.SUCCEEDED) {
          //@ts-expect-error we should change key in CEUI to payload and remove this
          const payload = action.payload || action.response;
          const {
            id: activeThemePresetObjectId
          } = payload.bufferedActiveThemePreset || {};
          const {
            activeThemePresetId
          } = payload;
          return Object.assign({}, state, {
            activeThemePresetObjectId,
            fetchActiveThemePresetBufferRequestStatus: action.requestStatus,
            publishedActiveThemePresetId: activeThemePresetId
          });
        }
        return state;
      }
    case THEME_SETTINGS_BUFFER_PUBLISHED:
      {
        if (action.requestStatus === RequestStatusTypes.SUCCEEDED) {
          const {
            publishedActiveThemePresetId,
            activeThemePresetObjectId
          } = action.payload || {};
          return Object.assign({}, state, {
            publishedActiveThemePresetId,
            activeThemePresetObjectId
          });
        }
        return state;
      }
    case SET_ACTIVE_PRESET:
      {
        return Object.assign({}, state, {
          ignoreUserThemeOverrides: false
        });
      }
    case SET_IS_PRESET_PANEL_OPEN:
      {
        const {
          isPresetPanelOpen,
          activeThemePresetId
        } = action.payload;
        return Object.assign({}, state, {
          selectedThemePresetId: isPresetPanelOpen ? activeThemePresetId : undefined
        });
      }
    case SET_SELECTED_PRESET:
      {
        return Object.assign({}, state, {
          selectedThemePresetId: action.selectedThemePresetId
        });
      }
    case CLEAR_SELECTED_PRESET:
      {
        return Object.assign({}, state, {
          selectedThemePresetId: undefined
        });
      }
    case CLEAR_ACTIVE_PRESET:
      {
        return Object.assign({}, state, {
          ignoreUserThemeOverrides: false
        });
      }
    case SET_IGNORE_USER_THEME_OVERRIDES:
      {
        const {
          ignoreUserThemeOverrides
        } = action;
        return Object.assign({}, state, {
          ignoreUserThemeOverrides
        });
      }
    case THEME_SETTINGS_CHANGE_UNDONE:
    case THEME_SETTINGS_CHANGE_REDONE:
      {
        const isPreviewingPreset = state.selectedThemePresetId !== undefined;
        if (!isPreviewingPreset && state.ignoreUserThemeOverrides) {
          return Object.assign({}, state, {
            ignoreUserThemeOverrides: false
          });
        }
        return state;
      }
    case THEME_SETTINGS_UPDATED:
      {
        return state.ignoreUserThemeOverrides ? Object.assign({}, state, {
          ignoreUserThemeOverrides: false
        }) : state;
      }
    default:
      return state;
  }
};
export default presetsReducer;